import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "./HeroAnimatedTitle.css";
import eventFlyer from "../../../Assets/storyfest/flyer2.jpeg"; 

const titles = [
  "WHERE LEADERSHIP IS BUILT",
  "AMPLE LEADERSHIP",
  "AMPLE PRODUCTIONS",
  "AMPLE EVENTS",
  "AMPLE PUBLICATIONS",
  "AMPLE ACADEMY",
];

const HeroAnimatedTitle = () => {
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % titles.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="ample-homehero-wrapper">
      
      {/* TEXT CONTENT */}
      <div className="ample-homehero-text-section">
        <div className="ample-homehero-label">
          ✦ A Global Leadership Platform
        </div>

        <AnimatePresence mode="wait">
          <motion.h1
            key={titles[index]}
            className="ample-homehero-title"
            initial={{ opacity: 0, y: 60 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -60 }}
            transition={{ duration: 0.8, ease: "easeInOut" }}
          >
            {titles[index]}
          </motion.h1>
        </AnimatePresence>

        <p className="ample-homehero-description">
          <strong className="ample-homehero-accent">Edu-Care. Communi-Care.</strong>
          <br /><br />
          Ample House is a global platform that develops individuals, families,
          educators, leaders, and institutions through publishing, productions,
          events, and academy-based learning.
        </p>

        <p className="ample-homehero-subtitle">
          <span className="ample-homehero-accent">Through</span>{" "}
          <span className="ample-homehero-accent">Ideas</span>.{" "}
          <span className="ample-homehero-accent">Stories</span>.{" "}
          <span className="ample-homehero-accent">Experience</span>.
        </p>
      </div>

      {/* FLYER SECTION */}
      <div className="ample-homehero-flyer-section">
        <div className="ample-homehero-flyer-container">
          <div className="ample-homehero-coming-soon-badge">Coming Soon</div>
          <img
            src={eventFlyer}
            alt="Event Flyer"
            className="ample-homehero-flyer-image"
          />
        </div>

        <div className="ample-homehero-flyer-details">
          <div className="ample-homehero-detail-item">
            <span className="ample-homehero-detail-icon">📅</span>
            <span>Date: 11th - 13th December 2026</span>
          </div>
          <div className="ample-homehero-detail-item">
            <span className="ample-homehero-detail-icon">📍</span>
            <span>Location: Accra City Hotel </span>
          </div>
        </div>

        {/* 👇 NEW: Explore StoryFest Button */}
        <button
          className="ample-homehero-explore-btn"
          onClick={() => navigate("/storyfest")}
        >
          Explore StoryFest <span className="ample-homehero-arrow">↗</span>
        </button>
      </div>

    </div>
  );
};

export default HeroAnimatedTitle;